import { combineReducers } from 'redux';

import {
  ARTIST_OWNERSHIPS_CHANGED
} from '../constants/myArtistsConstants';

const csrfToken = (state = "", action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const team = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const currentUser = (state = {}, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const dataTableTitle = (state = "", action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const dataTableDataSource = (state = "", action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const dataTableOrder = (state = [], action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const dataTableColumns = (state = [], action) => {
  switch (action.type) {
    default:
      return state;
  }
};

const artistOwnerships = (state = [], action) => {
  switch (action.type) {
    case ARTIST_OWNERSHIPS_CHANGED:
      return action.artistOwnerships;
    default:
      return state;
  }
};

const myArtistsReducer = combineReducers({
  csrfToken,
  team,
  currentUser,
  dataTableTitle,
  dataTableDataSource,
  dataTableOrder,
  dataTableColumns,
  artistOwnerships
});

export default myArtistsReducer;
